import {
  getGridStringOperators,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid';
import {
  DataGridPremium,
  DataGridPremiumProps,
  getGridBooleanOperators,
  getGridSingleSelectOperators,
  GRID_AGGREGATION_FUNCTIONS,
  GridActionsCellItem,
  GridAggregationFunction,
  GridCellParams,
  GridColDef,
  GridColTypeDef,
  GridColumnMenu,
  GridColumnMenuProps,
  GridComparatorFn,
  GridEventListener,
  GridFilterModel,
  GridGroupingColDefOverride,
  GridGroupNode,
  GridInitialState,
  GridLogicOperator,
  GridPaginationModel,
  GridRenderCellParams,
  GridRenderEditCellParams,
  GridRowGroupingModel,
  GridRowHeightParams,
  GridRowHeightReturnValue,
  GridRowId,
  GridRowIdGetter,
  GridRowParams,
  GridRowSelectionModel,
  GridRowSpacing,
  GridRowSpacingParams,
  GridRowsProp,
  GridValidRowModel,
  useGridApiContext,
  useGridApiRef,
  useKeepGroupedColumnsHidden,
  GridRowClassNameParams,
} from '@mui/x-data-grid-premium';
import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import type { GridProSlotProps } from '@mui/x-data-grid-pro/models/gridProSlotProps';

export type {
  GridColumnMenuProps,
  GridGroupingColDefOverride,
  GridRowId,
  GridInitialState,
  GridComparatorFn,
  GridFilterModel,
  GridRowGroupingModel,
  GridCellParams,
  GridGroupNode,
  GridRowHeightParams,
  GridRowHeightReturnValue,
  GridRowSpacingParams,
  GridRowsProp,
  DataGridPremiumProps,
  GridAggregationFunction,
  GridEventListener,
  GridRenderCellParams,
  GridRenderEditCellParams,
  GridRowIdGetter,
  GridRowSelectionModel,
  GridPaginationModel,
  GridRowParams,
  GridColDef,
  GridValidRowModel,
  GridRowSpacing,
  GridInitialStatePremium,
  GridProSlotProps,
  GridColTypeDef,
  GridRowClassNameParams,
};

const FilterOperators = {
  CONTAINS: 'contains',
  IS: 'is',
  IS_ANY_OFF: 'isAnyOf',
};

const selectFilterConfig = () => {
  return {
    type: 'singleSelect' as const,
    sortable: false,
    filterable: true,
    aggregable: false,
    groupable: false,
    pinnable: false,
    filterOperators: getGridSingleSelectOperators().filter(({ value }) =>
      [FilterOperators.IS].includes(value)
    ),
    valueOptions: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  };
};

const textFilterConfig = () => {
  return {
    sortable: false,
    filterable: true,
    aggregable: false,
    groupable: false,
    pinnable: false,
    hideFilterInput: false,
    filterOperators: getGridStringOperators().filter(({ value }) =>
      [FilterOperators.CONTAINS].includes(value)
    ),
  };
};

const noFilterConfig = () => {
  return {
    sortable: false,
    disableColumnMenu: true,
    filterable: false,
  };
};

export {
  GridLogicOperator,
  GridColumnMenu,
  getGridBooleanOperators,
  DataGridPremium,
  GRID_AGGREGATION_FUNCTIONS,
  useKeepGroupedColumnsHidden,
  useGridApiRef,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
  useGridApiContext,
  FilterOperators,
  selectFilterConfig,
  textFilterConfig,
  noFilterConfig,
};
